import algoliasearch from "algoliasearch";
import { getAlgoliaResults } from "@algolia/autocomplete-js";
import { createQuerySuggestionsPlugin } from "@algolia/autocomplete-plugin-query-suggestions";
import qs from "qs";
import { IndexUiState } from "instantsearch.js";

export const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_SEARCH_APP_ID,
  process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY
);

export const index = searchClient.initIndex(
  process.env.REACT_APP_ALGOLIA_INDICES_JOBS
);

export const autocompleteSearchSource = ({ query }: any) => [
  {
    sourceId: "products",
    getItems() {
      return getAlgoliaResults({
        searchClient,
        queries: [
          {
            indexName: process.env.REACT_APP_ALGOLIA_INDICES_JOBS,
            query,
            params: {
              filters: "type: Professionals",
            },
          },
        ],
      });
    },
  },
];

export const querySuggestionsPluginInCategory = createQuerySuggestionsPlugin({
  searchClient,
  indexName: process.env.REACT_APP_ALGOLIA_INDICES_QUERY_SUGGESTIONS as string,
});

export const createURLSearchState = (state: IndexUiState) => {
  return `?${qs.stringify(state)}`;
};
export const urlToObject = ({ search }: { search: string }) =>
  qs.parse(search.slice(1));
export const searchStateToUrl = (searchState: IndexUiState) =>
  searchState
    ? `${window.location.pathname}${createURLSearchState(searchState)}`
    : ``;
export const getTagsData = (meta: HTMLMetaElement[]) => {
  const keywords = meta.find((keywords) => keywords.attributes[0].value === 'keywords')?.content as string;
  const group = keywords?.match(/FJG([^,]+)/);
  const query = keywords?.match(/FJQ([^,]+)/);
  const country = keywords?.match(/FJC([^,]+)/);
  return {
    group: group ? group[1].replace(' ', ''): null,
    query: query ? query[1].replace(' ', ''): null,
    country: country ? country[1].replace(' ', ''): null,
  };
};
